import useScripts from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Scripts/useScripts'
import { useTranslation } from 'react-i18next'
import CreditBoosterEmpty from './CreditBoosterEmpty'
import CreditBoosterContent from './CreditBoosterContent'
import useAdditionalSaleScript from '../AdditionalSales/useAdditionalSaleScript'

const CreditBooster = () => {
  const { t } = useTranslation()
  const { scripts } = useScripts()
  const { scrollToAdditionalSaleTab } = useAdditionalSaleScript()

  const scriptArray = scripts && Object.entries(scripts).length > 0 ? Object.values(scripts) : []

  const maxCredit = scriptArray.reduce((sum, sale) => sum + sale.credits, 0)

  const currentValue = scriptArray.reduce((sum, sale) => (sale.sold ? sum + sale.credits : sum), 0)
  const reachedMax = currentValue === maxCredit

  if (scriptArray.length === 0) return <CreditBoosterEmpty t={t} />

  return (
    <CreditBoosterContent
      t={t}
      scriptArray={scriptArray}
      currentValue={currentValue}
      maxCredit={maxCredit}
      reachedMax={reachedMax}
      scrollToAdditionalSaleTab={scrollToAdditionalSaleTab}
    />
  )
}

export default CreditBooster
